export default __webpack_public_path__ + "static/media/indian-market-cloud.3860e8f6.png";